import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm } from 'redux-form'
import { findKey, get, isEqual, sortBy } from 'lodash'

import { MENU_TYPES } from '../../utils/menuTypes'
import CheckboxGroupItem from '../CheckboxGroupItem'
import Modal from '../Modal'
import { uuid } from 'uuidv4'

let Menus = ({
  currentVenueUuid,
  isNewSetting,
  eventId,
  attendant,
  allMenuSubTypes,
  formSubTypes,
  onFieldValueChange,
  attendantSetting,
  createAttendantSetting,
  updateAttendantSetting,
  formFields,
  formAltered,
  attendantMenuSubtypes,
  history,
}) => {
  const onSubtypeChange = e => {
    const subType = e.target.id
    let newFormSubTypes

    // TODO(mkramerl): This is storing the natural language version of the menu subtype; make sure
    // the POS will handle that or update what is being sent here.
    if (e.target.checked) {
      newFormSubTypes = [...formSubTypes, subType]
      onFieldValueChange('subTypes', newFormSubTypes)
    } else {
      newFormSubTypes = formSubTypes.filter(type => type !== subType)
      onFieldValueChange('subTypes', newFormSubTypes)
    }
  }

  const onSubmit = () => {
    const attendantUuid = get(attendant, 'uuid', '')
    let attendantSettingParams = {
      uuid: isNewSetting ? uuid() : get(attendantSetting, 'uuid', ''),
      employeeUuid: attendantUuid,
    }
    const menuSubtypes = formSubTypes.map(type => findKey(MENU_TYPES, menu => menu === type))
    attendantSettingParams = {
      ...attendantSettingParams,
      configuration: {
        ...get(attendantSetting, 'configuration', {}),
        menuSubtypes: menuSubtypes,
      },
      type: 'AppDeviceConfiguration::AttendantSetting',
      salesEventId: eventId,
    }

    isNewSetting
      ? createAttendantSetting(currentVenueUuid, attendantSettingParams)
      : updateAttendantSetting(attendantSettingParams)
  }

  const selectedMenuTypesAltered = !isEqual(sortBy(attendantMenuSubtypes), sortBy(formSubTypes))

  const disableUpdateButton = () => {
    let disableButton = true
    const updatedFieldsExist =
      formFields.map(field => formAltered(field)).includes(true) || selectedMenuTypesAltered
    disableButton = !updatedFieldsExist
    return disableButton
  }

  return (
    <Modal title="Menu Assignment" onClose={() => history.goBack()}>
      <div className="menus-assingment attendant-settings">
        <p className="menus-assingment__subheader">{attendant.name}</p>
        <p>Selected menus for this event</p>
        <div className="menus__header">Menus</div>
          <div>
            {allMenuSubTypes.map((menu, idx) => {
              const checked = formSubTypes.includes(menu)

              return (
                <CheckboxGroupItem
                  isIcon={false}
                  className="-grouped"
                  key={idx}
                  id={menu}
                  onChange={onSubtypeChange}
                  checked={checked}
                  label={menu}
                />
              )
            })}
          </div>
        <button className="btn -update" onClick={onSubmit} disabled={disableUpdateButton()}>
          Save settings
        </button>
      </div>
    </Modal>
  )
}

Menus = reduxForm({
  form: 'attendant-event-settings',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(Menus)

Menus.defaultProps = {
  currentVenueUuid: '',
  isNewSetting: false,
  eventId: '',
  attendant: {},
  allMenuSubTypes: [],
  formSubTypes: [],
  onFieldValueChange: () => {},
  attendantSetting: {},
  createAttendantSetting: () => {},
  updateAttendantSetting: () => {},
  formFields: [],
  formAltered: () => {},
  attendantMenuSubtypes: [],
  history: {},
}

Menus.propTypes = {
  currentVenueUuid: PropTypes.string,
  isNewSetting: PropTypes.bool,
  eventId: PropTypes.string,
  attendant: PropTypes.object,
  allMenuSubTypes: PropTypes.array,
  formSubTypes: PropTypes.array,
  onFieldValueChange: PropTypes.func,
  attendantSetting: PropTypes.object,
  createAttendantSetting: PropTypes.func,
  updateAttendantSetting: PropTypes.func,
  formFields: PropTypes.array,
  formAltered: PropTypes.func,
  attendantMenuSubtypes: PropTypes.array,
  history: PropTypes.object,
}

export default Menus
